(function(){
  const DEFAULT_DISCOUNT = 0.15;
  const BOOST_DISCOUNT = 0.20;
  const THRESHOLD = 149900;   // ₹1,499 in paise

  // Collections eligible for the 20% offer price
  const BOOST_COLLECTIONS = ['god-idols', 'puja-accessories'];

  // NEW: Diwali gift boxes – flat 20%, no minimum order (takes priority)
  const DIWALI_COLLECTIONS = ['festive-gift-boxes'];
  const DIWALI_DISCOUNT = 0.20;
  const DIWALI_CODE = 'DIWALI20';

  function getHandles(slot){
    return (slot.getAttribute('data-collections') || '')
      .split(',')
      .map(h => h.trim())
      .filter(Boolean);
  }

  function isDiwali(slot){
    return getHandles(slot).some(h => DIWALI_COLLECTIONS.includes(h));
  }

  function getDiscount(slot){
    if(isDiwali(slot)) return DIWALI_DISCOUNT;
    const isBoosted = getHandles(slot).some(h => BOOST_COLLECTIONS.includes(h));
    return isBoosted ? BOOST_DISCOUNT : DEFAULT_DISCOUNT;
  }

  // Returns code, subtext and pill text for the current slot
  function getOfferMeta(slot, discount){
    if(isDiwali(slot)){
      return {
        code: DIWALI_CODE,
        subHtml: `Use code <span class="aop-offer-code">${DIWALI_CODE}</span> · No minimum order`,
        pill: `FLAT ${Math.round(DIWALI_DISCOUNT*100)}% OFF`
      };
    }
    const code = discount === BOOST_DISCOUNT ? 'DIWALI20' : 'DIWALI15';
    return {
      code,
      subHtml: `Use code <span class="aop-offer-code">${code}</span> on orders ₹1499+`,
      pill: `EXTRA ${Math.round(discount*100)}% OFF`
    };
  }

  function formatMoney(paise){
    const rupees = (paise/100).toFixed(2);
    return `₹${rupees.replace(/\.00$/, '')}`;
  }

  function computeOffer(paise, discount){
    return Math.round(paise * (1 - discount));
  }

  function mountOfferBox(){
    const slot = document.querySelector('#aop-offer-slot[data-aop-pdp]');
    if(!slot) return;

    const priceSection = document.querySelector('[data-product-price]') ||
                         document.querySelector('.m-price') ||
                         document.querySelector('.product__price');
    if(!priceSection) return;

    if(!slot._rendered){
      const salePaise = Number(slot.getAttribute('data-price')) || 0;
      const discount = getDiscount(slot);
      const offerPaise = computeOffer(salePaise, discount);
      const offerPrice = formatMoney(offerPaise);
      const meta = getOfferMeta(slot, discount);

      slot.innerHTML = `
        <div class="aop-offer-box">
          <div class="aop-offer-left">
            <div class="aop-offer-title">
              <span class="aop-offer-icon">🏷️</span>
              <span class="aop-offer-head">Offer Price :</span> 
              <span class="aop-offer-price aop-price">${offerPrice}</span>
            </div>
            <div class="aop-offer-sub">${meta.subHtml}</div>
          </div>
          <div class="aop-offer-pill">${meta.pill}</div>
        </div>
      `;

      priceSection.parentNode.insertBefore(slot, priceSection.nextSibling);
      slot._rendered = true;
    }
  }

  function updateOfferPrice(){
    const slot = document.querySelector('#aop-offer-slot[data-aop-pdp]');
    if(!slot) return;

    const priceNode = document.querySelector('[data-product-price]');
    const vPrice = Number(slot.getAttribute('data-price'));
    const salePaise = vPrice || (priceNode ? Number(priceNode.getAttribute('data-price')) : 0);
    if(!salePaise) return;

    const discount = getDiscount(slot);
    const meta = getOfferMeta(slot, discount);
    const offer = computeOffer(salePaise, discount);

    const priceEl = slot.querySelector('.aop-price');
    if(priceEl) priceEl.textContent = formatMoney(offer);

    const pillEl = slot.querySelector('.aop-offer-pill');
    if(pillEl) pillEl.textContent = meta.pill;

    const subEl = slot.querySelector('.aop-offer-sub');
    if(subEl) subEl.innerHTML = meta.subHtml;
  }

  ['variant:change','product:variant-change','theme:variant:change'].forEach(ev=>{
    document.addEventListener(ev, function(e){
      if(e.detail && e.detail.variant){
        const slot = document.querySelector('#aop-offer-slot[data-aop-pdp]');
        if(slot) slot.setAttribute('data-price', e.detail.variant.price);
      }
      updateOfferPrice();
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    mountOfferBox();
    updateOfferPrice();
  });
})();